export default __webpack_public_path__ + "static/media/secury.c5c5350f.svg";